import script from "./ClapScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClapScreen.vue?vue&type=script&setup=true&lang=ts"

import "./ClapScreen.vue?vue&type=style&index=0&id=d7634438&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7634438"]])

export default __exports__